export var ROLEENUM;
(function (ROLEENUM) {
    ROLEENUM["ADHERENT"] = "4";
    ROLEENUM["AYANT_DROIT"] = "5";
    ROLEENUM["PROFESSIONNEL_DE_SANTE"] = "6";
    ROLEENUM["REPRESENTANT_LEGAL"] = "8";
    ROLEENUM["ADMINISTRATEUR_METIER"] = "13";
    ROLEENUM["CARE_PRESTATTION_SANTE_JUNIOR"] = "14";
    ROLEENUM["CARE_PRESTATTION_SANTE_CONFIRME"] = "15";
    ROLEENUM["CARE_PRESTATTION_SANTE_EXPERT"] = "16";
    ROLEENUM["CARE_COTISATION_SANTE_JUNIOR"] = "17";
    ROLEENUM["CARE_COTISATION_SANTE_CONFIRME"] = "18";
    ROLEENUM["CARE_COTISATION_SANTE_EXPERT"] = "19";
    ROLEENUM["MANAGER_CARE_SANTE"] = "24";
    ROLEENUM["SALARIE"] = "28";
})(ROLEENUM || (ROLEENUM = {}));
export var LIBELLEROLEENUM;
(function (LIBELLEROLEENUM) {
    LIBELLEROLEENUM["CARE"] = "Care";
    LIBELLEROLEENUM["MANAGER"] = "Manager";
    LIBELLEROLEENUM["ADHERENT"] = "Adherent";
})(LIBELLEROLEENUM || (LIBELLEROLEENUM = {}));
